import { AfterViewInit, Component, HostListener } from '@angular/core';
import { ESCAPE }                                 from '@angular/cdk/keycodes';
import { Router }                                 from '@angular/router';
import { HttpErrorResponse }                      from '@angular/common/http';

import { catchError } from 'rxjs/operators';

import { animationStates, fade } from '@shared/animations/animations';

import { ErrorService }   from '@utils/error/error.service';
import { OverlayService } from '@services/overlay.service';
import { UserService }    from '@services/user.service';
import { ApiUserService } from '@services/api-user.service';


@Component({
  selector:    'red-contract-overlay',
  templateUrl: './contract-overlay.component.html',
  styleUrls:   [ './contract-overlay.component.scss' ],
  animations:  [ fade ]
})
export class ContractOverlayComponent implements AfterViewInit {

  public isLoading:          boolean;
  public formAnimationState: animationStates;

  @HostListener('document:keydown', [ '$event' ])
  public handleKeydown(event: KeyboardEvent) {
    // noinspection JSDeprecatedSymbols
    if (event.keyCode === ESCAPE) this.cancel(event);
  }

  constructor(
    private router:         Router,
    private overlayService: OverlayService,
    private errorService:   ErrorService,
    private userService:    UserService,
    private apiUserService: ApiUserService
  ) {
    this.isLoading          = false;
    this.formAnimationState = 'void';
  }

  public ngAfterViewInit(): void {
    setTimeout(() => this.formAnimationState = 'enter', 0);
  }

  public accept(event?: Event) {
    if (this.isLoading) return;

    this.isLoading = true;

    const callback = () => this.isLoading = false;

    this.apiUserService.acceptContract().pipe(
      catchError((error: HttpErrorResponse) => this.errorService.handleFormError(error, callback))
    ).subscribe(() => {
      this.userService.contractAccepted = true;

      this.router.navigate([ '/' ], {
        queryParams: { contrato: null }
      }).then(() => this.overlayService.close('contract'));
    });

    if (event) event.preventDefault();
  }

  public cancel(event?: Event) {
    if (event) event.preventDefault();

    if (this.isLoading) return;

    this.userService.contractAccepted = false;
    this.userService.logout();

    this.router.navigate(['.'], {
      queryParams: { contrato: null }
    }).then(() => this.formAnimationState = 'leave');

  }

  public formAnimationDone() {
    if (this.formAnimationState === 'leave') {
      this.formAnimationState = 'void';
      this.overlayService.close('contract');
    }
  }

}
